// siteData.ts
import agrImgUri from '@/assets/agr.png'
import magnoxImgUri from '@/assets/magnox.png'
import ndaImgUri from '../assets/nda.png'
import edfImgUri from '../assets/edf.png'

export const sitesStatic = [
  { name: 'Dungeness', coords: [1, 51], src: agrImgUri },
  { name: 'Hinkley', coords: [-3, 51.2], src: edfImgUri },
  { name: 'Hartlepool', coords: [-1.2, 54.6], src: agrImgUri },
  { name: 'Heysham', coords: [-2.9, 54], src: agrImgUri },
  { name: 'Hunterston', coords: [-4.5, 55.5], src: agrImgUri },
  { name: 'Torness', coords: [-2.4, 56], src: agrImgUri },
  { name: 'Wylfa', coords: [-4.5, 53.4], src: magnoxImgUri },
  { name: 'Oldbury', coords: [-2.57, 51.6], src: magnoxImgUri },
  { name: 'Sellafield', coords: [-3.5, 54.4], src: ndaImgUri },
  { name: 'Bradwell', coords: [0.9, 51.7], src: magnoxImgUri },
  { name: 'Dounreay', coords: [-4, 58.5], src: ndaImgUri },
  { name: 'Chapelcross', coords: [-3.2, 55], src: magnoxImgUri },
  { name: 'Sizewell', coords: [1.6, 52.2], src: agrImgUri },
  { name: 'Trawsfynydd', coords: [-4, 53], src: magnoxImgUri },
  { name: 'Berkeley', coords: [-2.5, 51.7], src: magnoxImgUri },
  { name: 'Winfrith', coords: [-2.3, 50.6], src: magnoxImgUri }
]
